// File: client_serena/src/components/UserRejectedMeals.js
import React from "react";
import { Box, Text, VStack, Tag } from "@chakra-ui/react";

function UserRejectedMeals({ rejected = [] }) {
if (!rejected.length) return null;

return (
<Box mt={4} p={4} border="1px dashed gray" borderRadius="md" bg="gray.50">
<Text fontWeight="bold" mb={2}>
Rejected Meals
</Text>
<VStack align="start" spacing={3}>
{rejected.map((meal, i) => (
<Box key={i} p={3} border="1px solid #ccc" borderRadius="md" w="100%">
<Text fontWeight="semibold">{meal.name}</Text>
<Tag size="sm" colorScheme="red" mt={1}>
Reason: {meal.reason}
</Tag>
</Box>
))}
</VStack>
</Box>
);
}

export default UserRejectedMeals;